module.exports = __webpack_public_path__ + "img/user.fb241bdb.png";